/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

import template from './keyvalue-summary.component.html';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-key-value-summary',
  template
})
export class KeyvalueSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any[] = [];

  ngOnChanges(): void {
    this.data = [];
    _.forEach(this.targets || {}, (entryObj) => {
      const inputted: any[] = [];
      const notInputted: any[] = [];
      _.forEach(entryObj.entries, (v, k) => {
        const isNot = _.startsWith(k.toUpperCase(), 'NOT ');
        const nextLevelV = _.isArray(v[0]) ? v : [v];
        _.forEach(nextLevelV, (vLevel) => {
          inputted.push({k: isNot ? k.substr(4) : k, v: _.isEmpty(vLevel) ? '(any value)' : vLevel.join(', '), not: isNot});
        });
      });
      _.forEach(entryObj.notEntries, (v, k) => {
        const isNot = _.startsWith(k.toUpperCase(), 'NOT ');
        const nextLevelV = _.isArray(v[0]) ? v : [v];
        _.forEach(nextLevelV, (vLevel) => {
          notInputted.push({k: isNot ? k.substr(4) : k, v: _.isEmpty(vLevel) ? '(any value)' : vLevel.join(', '), not: isNot});
        });
      });
      this.data.push({entries: inputted, notEntries: notInputted});
    });
  }
}
